<template>
  <div class="singleRegister2">
    <div class="main">
      <van-form @submit="onSubmit" input-align="left">
        <div class="card">
          <div class="card_item">
            <van-field
              v-model="form.teacherName"
              name="teacherName"
              label="指导老师"
            />
          </div>
          <div class="card_item">
            <van-field
              v-model="form.teacherPhone"
              type="tel"
              name="teacherPhone"
              label="指导老师电话"
            />
          </div>
          <div class="card_item">
            <van-field
              v-model="form.agency"
              name="agency"
              label="推荐机构名称"
            />
          </div>
          <div class="card_item">
            <van-field
              v-model="form.repertoire"
              name="repertoire"
              label="参赛曲目"
              required
              :rules="rules.repertoire"
            />
          </div>
        </div>

        <div class="submit">
          <van-button block color="#00CBCC" type="primary" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>

    <!-- 报名成功 -->
    <van-popup v-model="popupShow" round>
      <div class="popup_main">
        <img class="close_icon" src="@/assets/olympicMusicShow/delete.png" @click="popupShow = false">
        <div class="success_icon_box">
          <img class="success_icon" src="@/assets/olympicMusicShow/success.png">
        </div>

        <div class="title">报名成功</div>
        <div class="text">请关注后续手机短信通知</div>

        <div class="btn">查看报名详情</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Form, Field, Uploader, Button, RadioGroup, Radio, Popup, Cell, Icon, Picker, Toast } from 'vant'

import { ApiSignupCompetition } from '@/api/olympicMusicShow.js'

export default {
  name: 'singleRegister2',
  components: {
    vanForm: Form,
    vanField: Field,
    vanUploader: Uploader,
    vanButton: Button,
    vanRadioGroup: RadioGroup,
    vanRadio: Radio,
    vanPopup: Popup,
    vanCell: Cell,
    vanIcon: Icon,
    vanPicker: Picker,
  },
  data() {
    return {
      form: {
        teacherName: null,
        teacherPhone: null,
        agency: null,
        repertoire: null,
      },
      rules: {
        repertoire: [{ required: true, message: '请填写参赛曲目' }],
      },
      popupShow: false
    }
  },
  computed: {
    selectCompetitiontype: {
      get() {
        return this.$store.state.olympicMusicShow.selectCompetitiontype
      }
    },
    competitiontypesName() {
      if (this.selectCompetitiontype) {
        return this.selectCompetitiontype.name
      } else {
        return ''
      }
    }
  },
  mounted() {
    document.title = this.competitiontypesName + '填写报名信息'
  },
  methods: {
    onSubmit() {
      this.$store.commit('olympicMusicShow/setSingleForm', this.form)

      ApiSignupCompetition({
        register: this.$store.state.olympicMusicShow.singleParams
      }).then(res => {
        if (res.code === 200) {
          this.popupShow = true
        } else {
          Toast(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/css/flexable.scss';

.singleRegister2 {
  .van-cell {
    padding: 0;
    padding-left: 16px;
  }
  .van-cell__title {
    font-size: px2rem(32);
    font-weight: 500;
    color: #1F1F1F;
  }
  
  .card_item {
    &.category {
      .van-radio-group--horizontal {
        justify-content: flex-end;
      }
      .van-radio {
        margin-bottom: 17px;
      }
    }

    .van-uploader__upload {
      margin-right: 0;
      margin-bottom: 0;
    }
  }
}
</style>

<style lang="scss">
@import '../../assets/css/flexable.scss';

.singleRegister2 {
  width: 100%;
  min-height: 100vh;
  background-color: #F5F5F9;
  .main {
    padding-top: px2rem(30);
    .card {
      margin-bottom: 3.73vw;
      width: 100%;
      padding: 0 3.73vw 0 4.27vw;
      background-color: #fff;
      box-sizing: border-box;
      &:last-child {
        margin-bottom: 0;
      }
      .card_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 4.27vw 0;
        border-bottom: 1px solid #F3F4F6;
        &:last-child {
          border-bottom: 0;
        }
      }
    }
    .submit {
      width: 100%;
      padding: 40px 20px 44px 20px;
      box-sizing: border-box;
    }
  }

  .popup_main {
    position: relative;
    width: px2rem(608);
    height: px2rem(647);
    .close_icon {
      position: absolute;
      top: px2rem(26);
      right: px2rem(26);
      z-index: 1;
      width: px2rem(52);
      height: px2rem(52);
    }
    .success_icon_box {
      margin-bottom: px2rem(73);
      width: 100%;
      padding-top: px2rem(103);
      .success_icon {
        display: block;
        margin: 0 auto;
        width: px2rem(261);
        height: px2rem(157);
      }
    }
    .title {
      margin-bottom: px2rem(22);
      text-align: center;
      font-size: px2rem(36);
      font-weight: bold;
      color: #1F1F1F;
      line-height: 1;
    }
    .text {
      margin-bottom: px2rem(70);
      text-align: center;
      font-size: px2rem(32);
      font-weight: 500;
      color: #585858;
      line-height: 1;
    }
    .btn {
      margin: 0 auto;
      width: px2rem(490);
      height: px2rem(95);
      text-align: center;
      line-height: px2rem(95);
      font-size: px2rem(30);
      font-weight: 500;
      color: #fff;
      border-radius: px2rem(47);
      background-color: #3AC8CA;
    }
  }
}
</style>